import EnHome from '@/views/en/1-EnHome.vue'

export const enRoutes = [
    {
        path: '',
        name: 'EnHome',
        component: EnHome,
    },
    {
        path: 'statistics',
        name: 'EnStatistics',
        component: () => import('@/views/en/2-EnStatistics.vue'),
    },
    {
        path: 'supply-chain',
        name: 'EnSupplyChain',
        component: () => import('@/views/en/4-EnSupplyChain.vue'),
        children: [
            {
                path: 'intro',
                name: 'EnSupplyChainIntro',
                component: () => import('@/views/en/4-1-EnIntro.vue'),
            },
            // {
            //     path: 'join',
            //     name: 'EnSupplyChainJoin',
            //     component: () => import('@/views/en/4-2-EnJoin.vue'),
            // },
            {
                path: 'companies/:type/:companyId',
                name: 'EnSupplyChainCompanies',
                component: () => import('@/views/en/4-1-1-EnCompanies.vue'),
            },
        ],
    },
    {
        path: 'cycle-badge',
        name: 'EnCycleBadge',
        component: () => import('@/views/en/5-EnCycleBadge.vue'),
        children: [
            {
                path: 'intro',
                name: 'EnCycleBadgeIntro',
                component: () => import('@/views/en/5-1-EnIntro.vue'),
            },
            {
                path: 'progress',
                name: 'EnCycleBadgeProgress',
                component: () => import('@/views/en/5-2-EnProgress.vue'),
            },
            {
                path: 'case',
                name: 'EnCycleBadgeCase',
                component: () => import('@/views/en/5-3-EnCase.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'EnCycleBadgeCaseList',
                        component: () => import('@/views/en/5-3-1-EnList.vue'),
                    },
                    {
                        path: 'detail/:companyId',
                        name: 'EnCycleBadgeCaseDetail',
                        component: () =>
                            import('@/views/en/5-3-2-EnDetail.vue'),
                    },
                ],
            },
        ],
    },
    {
        path: 'information',
        name: 'EnInformation',
        component: () => import('@/views/en/6-EnInformation.vue'),
        children: [
            // {
            //     path: 'document',
            //     name: 'EnInformationDocument',
            //     component: () => import('@/views/en/6-1-EnDocument.vue'),
            // },
            {
                path: 'image',
                name: 'EnInformationImage',
                component: () => import('@/views/en/6-2-EnImage.vue'),
            },
            {
                path: 'video',
                name: 'EnInformationVideo',
                component: () => import('@/views/en/6-3-EnVideo.vue'),
            },
        ],
    },
    {
        path: 'sitemap',
        name: 'EnSitemap',
        component: () => import('@/views/en/7-EnSitemap.vue'),
    },
]
